import React, { useContext, PropsWithChildren, useMemo } from 'react';

import { TrackingType } from '~/src/common/consumption/completion-snackbar';

interface Props {
  trackingType: TrackingType;
}

const AnalyticsContext = React.createContext<Props | null>(null);

export const AnalyticsProvider: React.FC<PropsWithChildren<Props>> = ({
  trackingType,
  children,
}) => {
  const value = useMemo(() => ({ trackingType }), [trackingType]);
  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
};

export const useAnalytics = () => {
  const value = useContext(AnalyticsContext);
  if (!value) throw new Error('Missing AnalyticsContext Provider');
  return value;
};
